import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-optional',
  styleUrls: ['./recap-optional.component.scss'],
  templateUrl: './recap-optional.component.html'
})
export class RecapOptionalComponent {
  @Input() public day: any;
  @Input() public serviceIcons: any;
  @Input() public version: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getActivityIcon(category: string): string | undefined {
    if (!category) {
      return undefined;
    }
    return `assets/custom/${this.version}/icons/activities/${category}.svg`;
  }
}
